// categoriasAlerta.ts — el nombre en castellano de cada categoría de alerta administrativa.
//
// El slug crudo de la categoría no le dice nada a nadie («stays_outbound_failed»). Acá vive su nombre legible. Una
// categoría sin entrada cae al slug, que es feo pero honesto: mejor eso que un rótulo genérico que oculte cuál es.
//
// Cada alerta nueva que levante el backend (`raiseAlert({ categoria })`) necesita su entrada acá. La de
// `bot_firma_rechazada` la levanta el endpoint del bot de WhatsApp cuando llega una firma u hora inválida
// (backend/src/middleware/botSignature.middleware.js): significa que alguien probó firmar contra el endpoint, o que
// el secreto compartido entre el backend y el servicio twilio no coincide.
export const CATEGORIA_LABEL: Record<string, string> = {
  stays_outbound_failed: "Sincronización a Stays",
  stays_property_not_found: "Propiedad no registrada",
  precio_bajo_minimo: "Precio bajo el mínimo",
  scrap_sin_ingesta: "Scraper sin datos",
  scrap_ingest_rechazado: "Ingesta rechazada",
  volumen_archivos: "Volumen de archivos",
  bot_firma_rechazada: "Firma del bot rechazada",
};

/** El nombre legible de una categoría; el slug tal cual si no se conoce. */
export const etiquetaCategoria = (categoria: string): string =>
  Object.prototype.hasOwnProperty.call(CATEGORIA_LABEL, categoria) ? CATEGORIA_LABEL[categoria] : categoria;
